module.exports = __webpack_public_path__ + "img/2015.02.2ff18738.jpg";